import { useCallback, useMemo, useState } from "react";

import { useSearchParamActions } from "../../../../hooks/useSearchParamActions";
import {
  getDateRangeHeading,
  getMissingStatusFilterSearchParams,
  getInitialSelectionRange,
  parseMissingStatusFilterParams,
} from "../utils/reportUtils";

export function useMissingStatusDateFilter(onClose) {
  const { searchParams, updateSearchParams, removeSearchParams } =
    useSearchParamActions();
  const filter = useMemo(
    () =>
      parseMissingStatusFilterParams({
        from: searchParams.get("missingStatusFrom"),
        days: searchParams.get("missingStatusDays"),
        missingStatus: searchParams.get("missingStatus"),
      }),
    [searchParams]
  );
  const [selectionRange, setSelectionRange] = useState(
    getInitialSelectionRange(filter)
  );

  const handleSelect = useCallback((ranges) => {
    setSelectionRange([ranges.selection]);
  }, []);

  const submitSelection = useCallback(() => {
    const { from, days } = getMissingStatusFilterSearchParams(selectionRange[0]);
    updateSearchParams([
      { name: "missingStatusFrom", value: from },
      { name: "missingStatusDays", value: String(days) },
      { name: "missingStatus", value: "" },
    ]);
    onClose?.();
  }, [onClose, selectionRange, updateSearchParams]);

  const resetSelection = useCallback(() => {
    onClose?.();
    removeSearchParams(["missingStatusFrom", "missingStatusDays", "missingStatus"]);
  }, [onClose, removeSearchParams]);

  return {
    filter,
    selectionRange,
    heading: getDateRangeHeading(filter),
    handleSelect,
    submitSelection,
    resetSelection,
  };
}
